
import { FunctionComponent, useState } from 'react';
import styles from "./UsersFishData.module.css";
import cn from 'classnames';
import { Card, Image } from 'react-bootstrap';
import { ASSESTS } from '../../../constant/assest';
import CustomButton, { ButtonType } from '../../common/CustomButton/CustomButton';
import React from 'react';
import ContentTabs, { IContentTabsTheme } from '../../common/ContentTabs/ContentTabs';

type IGallery = {
  id: number;
  snap: string;
  placeName: string;
};

interface IUsersFishDataProps {
    className?: string;
};

const pendingUsersFishDataList = [
    {   
        id: 1, 
        userImage: '', 
        userName: 'Mike Johnson',
        userEmail: 'Mike.j@email.com',
        lakeName: 'Crystal Lake',
        images: [
            {id: 1, snap: ASSESTS.LAKEDUMMY, placeName: 'Largemouth Bass'},
            {id: 2, snap: ASSESTS.LAKEDUMMY, placeName: 'Rainbow Trout'},
            {id: 3, snap: ASSESTS.LAKEDUMMY, placeName: 'Perch Fish'},
            {id: 4, snap: ASSESTS.LAKEDUMMY, placeName: 'Carp'},
        ],
        totalCatches: 4,
        totalWeight: 64,
     },
     {   
        id: 2, 
        userImage: '', 
        userName: 'Carlos Rodriguez',
        userEmail: 'Carl.rodriguez@email.com',
        lakeName: 'Pine River',
        images: [
            {id: 1, snap: ASSESTS.LAKEDUMMY, placeName: 'Largemouth Bass'},
            {id: 2, snap: ASSESTS.LAKEDUMMY, placeName: 'Rainbow Trout'},
        ],
        totalCatches: 14,
        totalWeight: 84,
     },
];
const UsersFishData: FunctionComponent<IUsersFishDataProps> = ({className }) => {

    const [activeContentTab, setActiveContentTab] = useState('All Locations');

    const userItem = (
        userImage: string, 
        userName: string,
        userEmail: string,
        lakeName: string,
        galleryImages: IGallery[],
        totalCatches: number,
        totalWeight: number,
        viewBtnCLick: () => void) => {
        return (
            <Card bsPrefix={cn(styles.pendingUsersCard)}>
                <Card.Body bsPrefix={styles.pendingUsersBody}>
                    <div className={styles.userCol}>
                        <div className={cn(styles.userImage, !userImage && styles.userDummyImage)}>
                            <Image src={userImage ? userImage : ASSESTS.DUMMYUSER} alt={userName} width={64} height={64} />
                        </div>
                        <div className={styles.userDetail}>
                            <Card.Title as={'div'} bsPrefix={styles.userName}>{userName}</Card.Title>
                            <Card.Text as={'div'} bsPrefix={styles.userEmail}>{userEmail}</Card.Text>
                            <span className={styles.lakeName}>{lakeName}</span>
                        </div>
                    </div>
                    <div className={styles.galleryCol}>
                        {galleryImages.map((gallery, idx) => (
                            gallery.snap &&
                            <div className={styles.galleryItem} key={`${gallery.id}-${idx}`}>
                                <div className={styles.image}>
                                    <Image src={gallery?.snap} alt={gallery.placeName} width={150} />
                                </div>
                                <Card.Text bsPrefix={styles.text}>{gallery.placeName}</Card.Text>
                            </div>
                        ))}
                    </div>
                    <div className={styles.actionCol}>
                        <CustomButton
                            onClick={viewBtnCLick}
                            className={styles.linkBtn}
                            btnType={ButtonType.NOSTYLE}
                        >
                            View details
                        </CustomButton>
                    </div>
                </Card.Body>
                <Card.Footer bsPrefix={styles.pendingUsersFooter}>
                    <span className={styles.label}>Total Catches-{totalCatches}</span>
                    <span className={styles.label}>Total Weight-{totalWeight} lbs</span>
                </Card.Footer>
            </Card>
        );
    };

    return (
        <Card bsPrefix={cn(styles.pendingUsersFishData, className)}>
            <Card.Title as={'div'} bsPrefix={styles.title}>Users Fish Data</Card.Title>
            <ContentTabs tabs={['All Locations', 'Crystal Lake', 'Pine River', 'Hidden Cove', 'Lake Lesina', 'River Thurso', 'Blagdon Lake']} 
                defaultActiveTab={activeContentTab} 
                tabOnClick={(tab) => setActiveContentTab(tab)}
                theme={IContentTabsTheme.GREEN} 
                className={styles.pendingUsersFishTabs}
            />
            <Card.Body bsPrefix={styles.body}>
                {pendingUsersFishDataList.map((item, idx) => (
                    <React.Fragment key={`${item.id}-${idx}`}>
                        {userItem(
                            item.userImage, 
                            item.userName, 
                            item.userEmail, 
                            item.lakeName, 
                            item.images, 
                            item.totalCatches, 
                            item.totalWeight, 
                            () => {}
                        )}
                    </React.Fragment>
                ))}
            </Card.Body>
        </Card>
    );
};

export default UsersFishData;
